import { ActionIcon, Button, Loader, Tooltip } from '@mantine/core';
import { IconVolume } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { SvgPlayStop } from '@mygpt/app/chat/components/icon';
import { useMedia } from '@mygpt/app/utils';
import { useMatch } from 'react-router-dom';

interface TTSButtonProps {
  text: string;
  isPlaying?: boolean;
  ttsLoading: boolean;
  onTTSPlayOrPause: (text: string) => void;
  enableTTS: boolean;
}

export const TTSButton: React.FC<TTSButtonProps> = ({ text, isPlaying, ttsLoading, onTTSPlayOrPause, enableTTS }) => {
  const { t } = useTranslation();
  const { isMobile } = useMedia();
  const match = useMatch('/widget/:botId');
  const isWidgetPage = !!match;

  if (!enableTTS) {
    return null;
  }

  const getMobileIcon = () => {
    if (ttsLoading) {
      return (
        <div className="flex items-center justify-center w-[20px] h-[20px]">
          <Loader size={16} color="gray" />
        </div>
      );
    }
    if (isPlaying) {
      return <SvgPlayStop size={20} />;
    }
    return <IconVolume size={20} color="gray" />;
  };

  const getMobileText = () => {
    if (isPlaying) {
      return t('completions.tts.stop');
    }
    return t('completions.tts.play');
  };

  if (isMobile && !isWidgetPage) {
    return (
      <div className="flex flex-col items-center flex-1">
        <Button
          size="sm"
          variant="default"
          onClick={() => onTTSPlayOrPause(text)}
          className="border-[#E4E7EC] rounded-md h-10 px-2 w-full flex items-center justify-center gap-1"
        >
          {getMobileIcon()}
          <span className="ml-1 text-xs text-gray-600">{getMobileText()}</span>
        </Button>
      </div>
    );
  }

  return (
    <Tooltip label={isPlaying ? t('completions.tts.stop') : t('completions.tts.play')} withArrow>
      <ActionIcon variant={'subtle'} color="indigo" onClick={() => onTTSPlayOrPause(text)}>
        {ttsLoading ? <Loader size="xs" /> : isPlaying ? <SvgPlayStop /> : <IconVolume color="gray" />}
      </ActionIcon>
    </Tooltip>
  );
};
